import axios from '@axios'

const PREFIX = '/logs'

export default {
  getLogsPaginados(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getTelas() {
    return axios.get(`${PREFIX}/telas`)
  },

  getEventos() {
    return axios.get(`${PREFIX}/eventos`)
  },

  getProcessos() {
    return axios.get(`${PREFIX}/processos`)
  },
}
